Librarian.ChangePasswordWindow = new Class({
    Extends: Librarian.Window,
    Binds: ["changePassword"],

    options: {
        id: "changePasswordWindow",
        width: 240,
        height: 190
    },

    initialize: function(options) {
        this.setOptions(options);

        // Set the title on init so that we can use the localization
        this.options.title = Librarian.Lang.getString("change_password");

        this.options.contentURL = Librarian.path.getLayoutsPath() + "pages/changepassword.html";

        this.parent(this.options);
    },

    onWindowLoaded: function() {
        this.parent();

        var itemEl = $("changePasswordCancelButton");
        if (itemEl)
            itemEl.addOnClick(this.close);

        itemEl = $("changePasswordOKButton");
        if (itemEl)
            itemEl.addOnClick(this.changePassword);

        itemEl = $("changePasswordOldPass");
        if (itemEl) {
            if (Librarian.sessionType == Librarian.Session.sessionTypes.sso)
                itemEl.hide();
            else {
                // Focus the old password box so that it's convenient for the user
                if (itemEl.isVisible())
                    itemEl.focus();
                itemEl.onkeydown = function(e) {
                    var evt = new Event(e);
                    if (evt.key == "enter")
                        this.changePassword();
                }.bind(this);
            }
        }

        itemEl = $("changePasswordNewPass");
        if (itemEl) {
            itemEl.onkeydown = function(e) {
                var evt = new Event(e);
                if (evt.key == "enter")
                    this.changePassword();
            }.bind(this);
        }

        itemEl = $("changePasswordConfirmPass");
        if (itemEl) {
            itemEl.onkeydown = function(e) {
                var evt = new Event(e);
                if (evt.key == "enter")
                    this.changePassword();
            }.bind(this);
        }
    },

    changePassword: function() {
        var oldPass = '',
            newPass = '',
            confirmPass = '',
            itemEl = $("changePasswordOldPass");
        if (itemEl)
            oldPass = itemEl.value;

        itemEl = $("changePasswordNewPass");
        if (itemEl)
            newPass = itemEl.value;

        itemEl = $("changePasswordConfirmPass");
        if (itemEl)
            confirmPass = itemEl.value;

        if (newPass == confirmPass) {
            if (newPass.length > 0 && (oldPass.length > 0 || Librarian.sessionType == Librarian.Session.sessionTypes.sso)) {
                Librarian.userSession = new Librarian.Session();
                Librarian.userSession.onUpdateComplete = function() {
                    Librarian.Utils.notification(Librarian.Lang.getString("change_password_complete"));
                    this.close();
                }.bind(this);
                Librarian.userSession.onFailure = Librarian.Utils.onFailure;

                Librarian.userSession.changePassword(oldPass || '', newPass, null, null);
            }
            else
                Librarian.Utils.error(Librarian.Lang.getString("change_password_missing"));
        }
        else
            Librarian.Utils.error(Librarian.Lang.getString("change_password_mismatch"));

        itemEl = null;
    }

});